/* src/routes/blog/arch-linux-new-install.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import Gallery from "../../../_components/Gallery.svelte.js";
import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";

function create_default_slot_8(ctx) {
	let t;

	return {
		c() {
			t = text("Mint");
		},
		l(nodes) {
			t = claim_text(nodes, "Mint");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (22:4) <LinkExternal href="https://www.gentoo.org/get-started/">
function create_default_slot_7(ctx) {
	let t;

	return {
		c() {
			t = text("Gentoo");
		},
		l(nodes) {
			t = claim_text(nodes, "Gentoo");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (18:2) <PostSection title="Something New">
function create_default_slot_6(ctx) {
	let t0;
	let linkexternal0;
	let t1;
	let linkexternal1;
	let t2;
	let current;

	linkexternal0 = new LinkExternal({
			props: {
				href: "https://www.linuxmint.com/",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "https://www.gentoo.org/get-started/",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("I have been contemplating re-installing my main OS. Currently I'm running\n    ");
			create_component(linkexternal0.$$.fragment);
			t1 = text("\n    ( 14 - Cinnamon) and Windows 7. I have always wanted to install\n    ");
			create_component(linkexternal1.$$.fragment);
			t2 = text("\n    , but I just can't bring myself to doing it, everything I read suggests it\n    will take hours upon hours to install. Then there's the maintenance,\n    apparently everything is compiled at install time, which can increase\n    installation times.");
		},
		l(nodes) {
			t0 = claim_text(nodes, "I have been contemplating re-installing my main OS. Currently I'm running\n    ");
			claim_component(linkexternal0.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n    ( 14 - Cinnamon) and Windows 7. I have always wanted to install\n    ");
			claim_component(linkexternal1.$$.fragment, nodes);
			t2 = claim_text(nodes, "\n    , but I just can't bring myself to doing it, everything I read suggests it\n    will take hours upon hours to install. Then there's the maintenance,\n    apparently everything is compiled at install time, which can increase\n    installation times.");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(linkexternal0, target, anchor);
			insert(target, t1, anchor);
			mount_component(linkexternal1, target, anchor);
			insert(target, t2, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(linkexternal0, detaching);
			if (detaching) detach(t1);
			destroy_component(linkexternal1, detaching);
			if (detaching) detach(t2);
		}
	};
}

// (43:6) <LinkExternal         href="https://wiki.archlinux.org/index.php/Installation_guide">
function create_default_slot_5(ctx) {
	let strong;
	let t;

	return {
		c() {
			strong = element("strong");
			t = text("DOCUMENTATION IS AMAZING");
		},
		l(nodes) {
			strong = claim_element(nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t = claim_text(strong_nodes, "DOCUMENTATION IS AMAZING");
			strong_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, strong, anchor);
			append(strong, t);
		},
		d(detaching) {
			if (detaching) detach(strong);
		}
	};
}

// (49:6) <LinkExternal href="https://wiki.archlinux.org/index.php/Beginners">
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("Beginners Guide");
		},
		l(nodes) {
			t = claim_text(nodes, "Beginners Guide");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (31:2) <PostSection title="Arch">
function create_default_slot_3(ctx) {
	let p0;
	let t0;
	let strong0;
	let t1;
	let t2;
	let strong1;
	let t3;
	let t4;
	let t5;
	let p1;
	let t6;
	let linkexternal0;
	let t7;
	let linkexternal1;
	let t8;
	let t9;
	let p2;
	let t10;
	let t11;
	let p3;
	let t12;
	let t13;
	let gallery;
	let current;

	linkexternal0 = new LinkExternal({
			props: {
				href: "https://wiki.archlinux.org/index.php/Installation_guide",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "https://wiki.archlinux.org/index.php/Beginners",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	gallery = new Gallery({
			props: {
				images: [
					"/content/blog/images/arch-linux-new-install/arch_initial_screenshot.png"
				]
			}
		});

	return {
		c() {
			p0 = element("p");
			t0 = text("I have been looking at\n      ");
			strong0 = element("strong");
			t1 = text("Arch Linux");
			t2 = text("\n      , and I think this provides a good middle ground. You get to build a\n      system running only what you configure and install, but it seems easier\n      and less daunting that a full\n      ");
			strong1 = element("strong");
			t3 = text("Gentoo");
			t4 = text("\n      install.");
			t5 = space();
			p1 = element("p");
			t6 = text("One thing I would like to highlight is that the\n      ");
			create_component(linkexternal0.$$.fragment);
			t7 = text("\n      , really really helpful, if you need to know it, it's in there. Check out\n      the\n      ");
			create_component(linkexternal1.$$.fragment);
			t8 = text("\n      if you need help getting going.");
			t9 = space();
			p2 = element("p");
			t10 = text("After 2 hours of work, here is what I have:");
			t11 = space();
			p3 = element("p");
			t12 = text("(It still needs a lot of work, this is simply the stock xfce, with\n      chromium installed)");
			t13 = space();
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			p0 = claim_element(nodes, "P", {});
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "I have been looking at\n      ");
			strong0 = claim_element(p0_nodes, "STRONG", {});
			var strong0_nodes = children(strong0);
			t1 = claim_text(strong0_nodes, "Arch Linux");
			strong0_nodes.forEach(detach);
			t2 = claim_text(p0_nodes, "\n      , and I think this provides a good middle ground. You get to build a\n      system running only what you configure and install, but it seems easier\n      and less daunting that a full\n      ");
			strong1 = claim_element(p0_nodes, "STRONG", {});
			var strong1_nodes = children(strong1);
			t3 = claim_text(strong1_nodes, "Gentoo");
			strong1_nodes.forEach(detach);
			t4 = claim_text(p0_nodes, "\n      install.");
			p0_nodes.forEach(detach);
			t5 = claim_space(nodes);
			p1 = claim_element(nodes, "P", {});
			var p1_nodes = children(p1);
			t6 = claim_text(p1_nodes, "One thing I would like to highlight is that the\n      ");
			claim_component(linkexternal0.$$.fragment, p1_nodes);
			t7 = claim_text(p1_nodes, "\n      , really really helpful, if you need to know it, it's in there. Check out\n      the\n      ");
			claim_component(linkexternal1.$$.fragment, p1_nodes);
			t8 = claim_text(p1_nodes, "\n      if you need help getting going.");
			p1_nodes.forEach(detach);
			t9 = claim_space(nodes);
			p2 = claim_element(nodes, "P", {});
			var p2_nodes = children(p2);
			t10 = claim_text(p2_nodes, "After 2 hours of work, here is what I have:");
			p2_nodes.forEach(detach);
			t11 = claim_space(nodes);
			p3 = claim_element(nodes, "P", {});
			var p3_nodes = children(p3);
			t12 = claim_text(p3_nodes, "(It still needs a lot of work, this is simply the stock xfce, with\n      chromium installed)");
			p3_nodes.forEach(detach);
			t13 = claim_space(nodes);
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, p0, anchor);
			append(p0, t0);
			append(p0, strong0);
			append(strong0, t1);
			append(p0, t2);
			append(p0, strong1);
			append(strong1, t3);
			append(p0, t4);
			insert(target, t5, anchor);
			insert(target, p1, anchor);
			append(p1, t6);
			mount_component(linkexternal0, p1, null);
			append(p1, t7);
			mount_component(linkexternal1, p1, null);
			append(p1, t8);
			insert(target, t9, anchor);
			insert(target, p2, anchor);
			append(p2, t10);
			insert(target, t11, anchor);
			insert(target, p3, anchor);
			append(p3, t12);
			insert(target, t13, anchor);
			mount_component(gallery, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p0);
			if (detaching) detach(t5);
			if (detaching) detach(p1);
			destroy_component(linkexternal0);
			destroy_component(linkexternal1);
			if (detaching) detach(t9);
			if (detaching) detach(p2);
			if (detaching) detach(t11);
			if (detaching) detach(p3);
			if (detaching) detach(t13);
			destroy_component(gallery, detaching);
		}
	};
}

// (72:4) <LinkExternal href="https://wiki.archlinux.org/index.php/ECryptfs">
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("ecryptfs Arch Guide");
		},
		l(nodes) {
			t = claim_text(nodes, "ecryptfs Arch Guide");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (65:2) <Callout>
function create_default_slot_1(ctx) {
	let t0;
	let strong0;
	let t1;
	let t2;
	let strong1;
	let t3;
	let t4;
	let linkexternal;
	let current;

	linkexternal = new LinkExternal({
			props: {
				href: "https://wiki.archlinux.org/index.php/ECryptfs",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("Something to note is that my previous install of\n    ");
			strong0 = element("strong");
			t1 = text("Mint");
			t2 = text("\n    had encrypted my home folders with\n    ");
			strong1 = element("strong");
			t3 = text("ecryptfs");
			t4 = text("\n    (standard ubuntu encryption). This was easily used with my new install by\n    following the Auto-Mount steps in this\n    ");
			create_component(linkexternal.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "Something to note is that my previous install of\n    ");
			strong0 = claim_element(nodes, "STRONG", {});
			var strong0_nodes = children(strong0);
			t1 = claim_text(strong0_nodes, "Mint");
			strong0_nodes.forEach(detach);
			t2 = claim_text(nodes, "\n    had encrypted my home folders with\n    ");
			strong1 = claim_element(nodes, "STRONG", {});
			var strong1_nodes = children(strong1);
			t3 = claim_text(strong1_nodes, "ecryptfs");
			strong1_nodes.forEach(detach);
			t4 = claim_text(nodes, "\n    (standard ubuntu encryption). This was easily used with my new install by\n    following the Auto-Mount steps in this\n    ");
			claim_component(linkexternal.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, strong0, anchor);
			append(strong0, t1);
			insert(target, t2, anchor);
			insert(target, strong1, anchor);
			append(strong1, t3);
			insert(target, t4, anchor);
			mount_component(linkexternal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal_changes.$$scope = { dirty, ctx };
			}

			linkexternal.$set(linkexternal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(strong0);
			if (detaching) detach(t2);
			if (detaching) detach(strong1);
			if (detaching) detach(t4);
			destroy_component(linkexternal, detaching);
		}
	};
}

// (16:0) <PostContents>
function create_default_slot(ctx) {
	let postsection0;
	let t0;
	let postsection1;
	let t1;
	let callout;
	let current;

	postsection0 = new PostSection({
			props: {
				title: "Something New",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	postsection1 = new PostSection({
			props: {
				title: "Arch",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	callout = new Callout({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postsection0.$$.fragment);
			t0 = space();
			create_component(postsection1.$$.fragment);
			t1 = space();
			create_component(callout.$$.fragment);
		},
		l(nodes) {
			claim_component(postsection0.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(postsection1.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(callout.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postsection0, target, anchor);
			insert(target, t0, anchor);
			mount_component(postsection1, target, anchor);
			insert(target, t1, anchor);
			mount_component(callout, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection0_changes.$$scope = { dirty, ctx };
			}

			postsection0.$set(postsection0_changes);
			const postsection1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection1_changes.$$scope = { dirty, ctx };
			}

			postsection1.$set(postsection1_changes);
			const callout_changes = {};

			if (dirty & /*$$scope*/ 4) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection0.$$.fragment, local);
			transition_in(postsection1.$$.fragment, local);
			transition_in(callout.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection0.$$.fragment, local);
			transition_out(postsection1.$$.fragment, local);
			transition_out(callout.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postsection0, detaching);
			if (detaching) detach(t0);
			destroy_component(postsection1, detaching);
			if (detaching) detach(t1);
			destroy_component(callout, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[1],
				projects: /*projects*/ ctx[0]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "Arch Linux New Install";
const date = "2014-01-31";

function instance($$self) {
	const projects = [];
	const tags = ["setup", "software"];
	return [projects, tags];
}

class Arch_linux_new_install extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Arch_linux_new_install;
//# sourceMappingURL=arch-linux-new-install.svelte.js.map
